/**
 * アプリケーション共通ログユーティリティ
 */

export type LogLevel = "error" | "warn" | "info" | "debug";

export interface LogContext {
  module: string;
  action: string;
}

/**
 * 環境に応じたログ出力
 * @param level ログレベル
 * @param context ログコンテキスト
 * @param message メッセージ
 * @param data 追加データ
 */
export function logMessage(level: LogLevel, context: LogContext, message: string, data?: unknown): void {
  if (process.env.NODE_ENV === "development") {
    const logPrefix = `[${context.module}] ${context.action}:`;

    switch (level) {
      case "error":
        console.error(logPrefix, message, data);
        break;
      case "warn":
        console.warn(logPrefix, message, data);
        break;
      case "info":
        console.info(logPrefix, message, data);
        break;
      case "debug":
        console.debug(logPrefix, message, data);
        break;
      default:
        console.log(logPrefix, message, data);
        break;
    }
  }

  // 本番環境では適切なロガーまたは監視システムに送信
  // TODO: 本番用ログ収集システムとの統合
}

/**
 * エラーログ専用のヘルパー関数
 * @param context ログコンテキスト
 * @param message エラーメッセージ
 * @param error エラー情報
 */
export function logError(context: LogContext, message: string, error?: unknown): void {
  logMessage("error", context, message, error);
}

/**
 * 警告ログ専用のヘルパー関数
 * @param context ログコンテキスト
 * @param message 警告メッセージ
 * @param data 追加データ
 */
export function logWarn(context: LogContext, message: string, data?: unknown): void {
  logMessage("warn", context, message, data);
}

/**
 * 情報ログ専用のヘルパー関数
 * @param context ログコンテキスト
 * @param message 情報メッセージ
 * @param data 追加データ
 */
export function logInfo(context: LogContext, message: string, data?: unknown): void {
  logMessage("info", context, message, data);
}

/**
 * API クライアント用のログコンテキスト生成ヘルパー
 * @param clientName クライアント名
 * @param action アクション名
 * @returns LogContext
 */
export function createApiLogContext(clientName: string, action: string): LogContext {
  return {
    module: `${clientName}Client`,
    action,
  };
}
